import { atom } from "jotai/index";

export const mobileSearchActiveAtom = atom<boolean>(false);
